import qs from 'qs';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import DocumentMeta from 'react-document-meta';

import Layout from '../Base/Layout';
import MainBuy from './Buy/MainBuy';
import ObjectsAPI from '../../api/Objects';
import MainRental from './Rental/MainRental';
import * as ImageUtils from '../../utils/Image';
import YouWillAlsoLike from './YouWillAlsoLike';
import {createOrder} from '../../actions/Orders';
import {showAuthModal} from '../../actions/User';
import BookingModal from './Rental/BookingModal';
import * as ObjectUtils from '../../utils/Property';
import * as OrderConst from '../../constants/Order';
import * as ImageConst from '../../constants/Image';
import * as ObjectConst from '../../constants/Property';
import * as RoutePaths from '../../constants/RoutePaths';
import {getObjectById, setYouWillAlsoLike} from '../../actions/ObjectPage';

const defaultProps = {
    setYouWillAlsoLike: () => {
    },
    getObjectById: (id, embed) => {
    },
    showAuthModal: isShowAuthModal => {
    },
    createOrder: ordersCreateCommand => {
    }
};

class PropertyPage extends Component {
    state = {
        isOpenBookingModal: false
    };

    componentDidMount() {
        this.props.getObjectById(
            this.props.match.params.id,
            [ObjectConst.EMBED.IMAGES, ObjectConst.EMBED.USER, ObjectConst.EMBED.TRANSLATES]
        ).then(()=>{
            // После подгрузки у нас появляется тип объекта и можно подгружать "You Will also like"
            this.props.setYouWillAlsoLike(this.getRequiredType());
        }).catch((error)=>{
           window.location = '/404';
        });
    }

    componentDidUpdate({match}) {
        const oldObjectId = match.params.id;
        const newObjectId = this.props.match.params.id;

        if (oldObjectId !== newObjectId) {
            window.scrollTo(0, 0);
            window.location.reload();
        }
    }

    handleBtnClick = event => {
        const {accessToken, objectId, userId} = this.props;

        event.preventDefault();

        if (this.getRequiredType() === ObjectConst.TYPE.SELL) {
            if (accessToken === null) {
                this.props.showAuthModal(true);
            } else {
                ObjectsAPI.requestForPurchase(objectId, userId);

                this.setState({
                    isShowPurchaseConfirmModal: true
                });
                this.createOrder(OrderConst.SERVICE_TYPE.PURCHASE);
            }
        } else {
            if (accessToken === null) {
                this.props.showAuthModal(true);

                return;
            }

            this.setState({
                isOpenBookingModal: true
            });
        }
    };

    closeBookingModal = () => {
        this.setState({
            isOpenBookingModal: false
        });
    };

    createOrder(serviceType) {
        const {firstName, lastName, email, code} = this.props;
        const ordersCreateCommand = {
            serviceType: serviceType,
            userName: `${firstName} ${lastName}`,
            contactData: email,
            languageName: code
        };
        this.props.createOrder(ordersCreateCommand);
    }

    getDisplayName = () => {
        const {code, translates, isShowOriginal, displayName} = this.props;
        let response;

        if (translates !== undefined && translates !== null && code !== undefined) {
            if (isShowOriginal) {
                response = displayName;
            } else {
                response = ObjectUtils.getTranslateByCode(translates, code).displayName;
            }
        } else {
            response = '';
        }
        return response;
    };

    getRequiredType = () => {
        const params = qs.parse(window.location.search.substring(1));
        let {type} = params;
        const {objectType, searchType} = this.props;
        let response;

        if (type !== undefined) {
            response = type;
        } else {
            if (objectType === ObjectConst.TYPE.RENT || (objectType === ObjectConst.TYPE.ALL && searchType === ObjectConst.TYPE.RENT)) {
                response = ObjectConst.TYPE.RENT;
            } else {
                response = ObjectConst.TYPE.SELL;
            }
        }
        return response;
    };

    getMain = () => {
        if (this.getRequiredType() === ObjectConst.TYPE.RENT) {
            return <MainRental />;
        } else {
            return <MainBuy />;
        }
    };

    render() {
        const {i18n, currentObject, status, objectId, objectType} = this.props;
        const displayName = this.getDisplayName();

        const meta = {
            title: displayName,
            meta: {
                property: {
                    'og:url': window.location.href,
                    'og:title': currentObject.description.displayName,
                    'og:description': currentObject.description.description,
                    'og:image': currentObject.meta.images !== null && currentObject.meta.images.length !== 0 ?
                        ImageUtils.getSrc(currentObject.meta.images[0].id, ImageConst.TYPE.RESIZED) : ''
                }
            }
        };

        return (
            <DocumentMeta {...meta}>
                <div className="page-inside">
                    <Layout
                        showPromoSlider={true}
                        title={displayName}
                    >
                        {objectId !== undefined && this.getMain()}

                        <YouWillAlsoLike requiredType={this.getRequiredType()} />

                        <a href="" className="btn pinned" onClick={this.handleBtnClick}>
                            {objectType === ObjectConst.TYPE.SELL ?
                                i18n['objectPage.requestForPurchase'] :
                                i18n['objectPage.reservation']}
                        </a>
                    </Layout>
                </div>

                <BookingModal isOpen={this.state.isOpenBookingModal} closeModal={this.closeBookingModal} />
            </DocumentMeta>
        )
    }
}

PropertyPage.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectPage: state.objectPage,
    email: state.user.currentUser.email,
    userId: state.user.currentUser.userId,
    lastName: state.user.currentUser.lastName,
    code: state.languages.currentLanguage.code,
    objectId: state.objectPage.currentObject.id,
    firstName: state.user.currentUser.firstName,
    currentObject: state.objectPage.currentObject,
    searchType: state.searchPage.requestParams.type,
    accessToken: state.user.currentUser.accessToken,
    isShowOriginal: state.objectPage.isShowOriginal,
    status: state.objectPage.currentObject.props.status,
    objectType: state.objectPage.currentObject.props.type,
    translates: state.objectPage.currentObject.meta.translates,
    userRepresent: state.objectPage.currentObject.meta.userRepresent,
    displayName: state.objectPage.currentObject.description.displayName,
});

const mapDispatchToProps = {
    createOrder,
    getObjectById,
    showAuthModal,
    setYouWillAlsoLike
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PropertyPage));



// WEBPACK FOOTER //
// ./src/components/PropertyPage/PropertyPage.js